<template>
    <section class="flex flex-row justify-between items-center gap-4 mb-6">
        <div class="flex items-center justify-start gap-3">
            <AppButton
                @click.stop.prevent="() => $emit('csvExport')"
                icon="file-download"
                text="CSV"
                :disabled="isDownloading || inert || isCsvDisabled"
                :loading="isDownloading"
            />
            <div
                class="type-tertiary flex gap-2 items-center"
                v-if="computedModel.size"
            >
                <div class="w-fit">
                    <SeclockMultiselect
                        v-model="computedModel.size"
                        :options="[10, 25, 50]"
                        label="Show"
                        label-position="side"
                        :contrast="false"
                        @change="(x) => updateSize(x)" />
                </div>
            </div>
        </div>
        <div class="flex items-center gap-3">
            <slot name="default" />
            <SearchInput
                v-if="!searchHidden"
                class="w-56 h-10"
                type="text"
                placeholder="Search"
                v-model="computedModel.query"
                @keydown.enter="(x) => updateQuery(x.target.value)"
                @clear="() => updateQuery('')"
            />
        </div>
    </section>
</template>

<script setup>
import { AppButton, SearchInput, SeclockMultiselect } from "@/Components";
import {computed, ref} from "vue";

const props = defineProps([
    "modelValue",
    "searchHidden",
    "isDownloading",
    "isCsvDisabled",
]);
const emit = defineEmits(["update:modelValue", "csvExport", "change"]);

function updateSize(size) {
    computedModel.value = {
        ...computedModel.value,
        size,
    };
}

function updateQuery(query) {
    computedModel.value = {
        ...computedModel.value,
        query,
    };
}

let computedModel = computed({
    // getter
    get() {
        return props.modelValue;
    },
    // setter
    set(newValue) {
        emit("update:modelValue", newValue);
        emit("change", newValue);
    },
});
</script>
